<template>
  <div class="py-8">
    <div class="font-medium text-md text-text flex items-start lg:items-center cursor-pointer"
         @click="showAnswer = !showAnswer">
      <div class="flex-none w-4 h-4 bg-border-hover rounded-full mr-4" :class="{'bg-green':showAnswer}"></div>
      <div>{{ question }}</div>
      <IconCross class="w-5 ml-auto transform transition duration-200"
                 :class="showAnswer ? '-rotate-0 text-red' : 'rotate-45 text-text-ternary'"/>
    </div>
    <TransitionCollapseHeight>
      <div v-show="showAnswer" class="ml-8 mr-12 text-sm text-text-label leading-tight">
        <div class="pt-8" v-html="answer">
        </div>
      </div>
    </TransitionCollapseHeight>
  </div>
</template>

<script>
import IconCross from "@/components/icons/IconCross";
import TransitionCollapseHeight from "@/components/transitions/TransitionCollapseHeight";

export default {
  name: "TicketsFAQGroupItem",
  components: {TransitionCollapseHeight, IconCross},
  props: {
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showAnswer: false
    }
  }
}
</script>